import { Form, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  openProposal,
  setRendererFormState,
  setSelectValidError,
  updateRendererFormState,
} from "../../../../slices/common/reducer";
import "../Order.scss";
import { useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { CopyIcon } from "../../../../assets/images/svg/svg";
import {
  checkAllRequiredDocumentsUploaded,
  getDependentAttributeValues,
  getFormRenderer,
  getSendOrderLink,
  readData,
  readPrposalData,
  updateProposalForm,
} from "../OrderService";
import useProposalFormData, {
  denormalizeProposalRecord,
} from "../Hook/useProposalFormData";
import { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import rootReducer from "../../../../store";
import { showToast } from "../../../../common/Toaster/Toaster";
import { useParams } from "react-router-dom";
import {
  checkButtonAccess,
} from "../../../../Utils/CommonUtils";
import { setDoctorCategory } from "../../../../slices/orders/orderSlice";
import ProposalForm from "../SelectedOrders/ProposalForm";

const ProposalModal = () => {
  const dispatch = useDispatch();
  const proposalShow = useSelector((state) => state.common.proposalShow);
  const [showFinishBtn, setShowFinishBtn] = useState(false);
  const formState = useSelector((state) => state.common.formRendererState);
  const ProposalFieldsJSON = useSelector(
    (state) => state.order.ProposalFieldsJSON,
  );
  const ProposalRulesJSON = useSelector(
    (state) => state.order.ProposalRulesJSON,
  );
  const isNewRenderer = useSelector((state) => state.order.isNewRenderer);
  // console.log("sjdhuygufid - ", ProposalRulesJSON);
  const { id } = useParams();
  const ProposalLayoutJSON = useSelector(
    (state) => state.order.ProposalLayoutJSON || [],
  );
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData,
  );
  const proposalJson = useSelector((state) => state.order.proposalJson);
  const agOrgId = useSelector((state) => state.header.agOrgId);
  const header = useSelector((state) => state.header.dropdownData.AG);
  // const [newAgOrgId, setNewAgOrgId] = useState();

  // const [isEditing, setIsEditing] = useState(false);
  const [isEditing, setIsEditing] = useState(!detailsData?.proposal_complete);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  const [index, setIndex] = useState(0);
  const [mode, setMode] = useState(
    detailsData?.proposal_complete ? "VIEW" : "EDIT",
  );

  // Owned here (not in ProposalForm) so Save Draft can read its live values;
  // fetched in both modes since view mode needs it too.
  const {
    data: craftFormData,
    isLoading: craftFormLoading,
    isError: craftFormError,
  } = useProposalFormData(id, mode, selectedUser?.organizationid, isNewRenderer);
  const craftFormMethods = useForm({
    values: craftFormData,
    mode: "onChange",
  });
  const craftFormValues = useWatch({ control: craftFormMethods.control });

  const handlePrevious = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  useEffect(() => {
    if (proposalShow) {
      readPrposalData(id, mode, selectedUser.organizationid);
    }
  }, [mode, proposalShow]);

  useEffect(() => {
    const qualValue = formState?.dn_highqual || proposalJson?.dn_highqual;
    if (qualValue && detailsData?.entityid) {
      getDependentAttributeValues(
        detailsData?.product_id,
        "qualification",
        qualValue,
      ).then((response) => {
        if (response) {
          const categoryValue =
            response.attribute_lov_label ||
            response.default_values ||
            response.doctor_category ||
            response[0]?.default_values;

          dispatch(
            setRendererFormState({
              key: "doctor_category",
              value: categoryValue,
            }),
          );
          // Also update doctorCategory in order slice to ensure components can react to it
          dispatch(setDoctorCategory(response));
        }
      });
    }
  }, [
    formState?.dn_highqual,
    proposalJson?.dn_highqual,
    detailsData?.entityid,
    dispatch,
  ]);

  const handleSubmit = async (e, action) => {
    e.preventDefault();

    if (isNewRenderer) {
      return;
    }

    if (formState) {
      dispatch(setSelectValidError(false));
      if (
        isEditing &&
        index < ProposalLayoutJSON.length - 1 &&
        action !== "save"
      ) {
        setIndex(index + 1);
      } else {
        try {
          const allDocsUploaded = checkAllRequiredDocumentsUploaded(
            formState,
            ProposalFieldsJSON,
          );
          const proposalFilledFlag = allDocsUploaded ? 1 : 0;

          const response = await updateProposalForm(
            formState,
            detailsData.entityid,
            "ODR",
            detailsData.status,
            proposalFilledFlag,
          );

          if (response && response.status === 200) {
            showToast("Proposal form updated successfully", "success");
            // Close the modal first so readData is allowed to restore the
            // order entity into formRendererState (it is skipped while open).
            dispatch(openProposal(false));
            await readData(id, "ODR");
          }
          dispatch(openProposal(false));
        } catch (error) {
          const errorMessage =
            error?.response?.data?.error_message || "An error occurred";
          showToast(errorMessage, "error");
        }
      }
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  const handleClose = () => {
    dispatch(openProposal(false));
    if (id) {
      readData(id, "ODR");
    }
  };

  const handleEditClick = () => {
    setIsEditing(!isEditing);
    setMode("EDIT");
  };

  const handleSaveDraft = async (e, showToastMsg = true) => {
    if (e && e.preventDefault) e.preventDefault();
    const draftValues =
      isEditing && isNewRenderer
        ? denormalizeProposalRecord(
            craftFormMethods.getValues(),
            ProposalFieldsJSON,
          )
        : formState;
    try {
      const response = await updateProposalForm(
        draftValues,
        detailsData?.entityid,
        "ODR",
        detailsData?.status,
        0,
      );
      if (response && showToastMsg) {
        showToast("Saved draft successfully", "success");
      }
    } catch (error) {
      showToast(
        error?.response?.data?.error_message || "Failed to save draft",
        "error",
      );
    }
  };

  // Workaround for reactstrap's Modal swallowing the craft-form renderer's
  // MUI popper fields (date/time pickers, select/multiselect) not closing on
  // outside click. reactstrap's handleBackdropClick (reactstrap/esm/Modal.js)
  // calls e.stopPropagation() on virtually every plain click inside the
  // modal, which — since that also halts the underlying native event — stops
  // it from ever reaching document, where MUI's own "click away" listener
  // for these poppers (bubble-phase, no capture) is registered. Escape still
  // gets through: MUI's Escape handler is `document.addEventListener
  // ('keydown', ...)` with no target check, so dispatching it directly on
  // `document` closes whichever popper is open regardless of how the click
  // that triggered it was swallowed.
  // `onMouseDown`/`onClick` on ModalBody (a descendant of reactstrap's own
  // click-eating wrapper) fire in that order, and before reactstrap's
  // handler, so: (1) mousedown snapshots which poppers were open before this
  // gesture — this is what lets a click that OPENS a picker (nothing open
  // yet) tell apart from a click meant to close an already-open one; (2) by
  // the time click fires, the target's own handlers (e.g. the picker's
  // toggle icon) have already run, so a real re-click on that icon closes
  // via its own logic and this only ever no-ops or closes a genuinely
  // different, already-open popper.
  const openPoppersOnMouseDownRef = useRef([]);

  const handleModalBodyMouseDown = () => {
    openPoppersOnMouseDownRef.current = Array.from(
      document.querySelectorAll('[class*="Popper" i]'),
    );
  };

  const handleModalBodyClick = (e) => {
    const openPoppers = openPoppersOnMouseDownRef.current;
    if (openPoppers.length === 0) return;

    const clickedInsideAnOpenPopper = openPoppers.some(
      (popper) => popper.isConnected && popper.contains(e.target),
    );
    if (clickedInsideAnOpenPopper) return;

    document.dispatchEvent(
      new KeyboardEvent("keydown", { key: "Escape", bubbles: true }),
    );
  };

  const renderProposalJson = () => {
    if (!proposalJson) return <p>No proposal data available</p>;

    // const parsedProfile = proposalJson;
    const parsedProposal = proposalJson;
    const fieldsLookup = Object.values(ProposalFieldsJSON).reduce(
      (acc, field) => {
        acc[field["database-label"]] = field;
        return acc;
      },
      {},
    );

    const formatDate = (value) => {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return value;
    };

    const formatYear = (value) => {
      if (!value) return value;

      // If value is a date string like "01-01-2025"
      if (typeof value === "string") {
        // Match DD-MM-YYYY or YYYY
        const match = value.match(/(\d{4})/);
        if (match) return match[1];
      }

      // If value is a real date object
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.getFullYear();
      }

      return value;
    };

    const renderChildFields = (childData) => {
      const fields = [];

      childData?.forEach((child, index) => {
        if (child.elementtype === "fieldset") {
          const labelKey = `${child.elementid}-${child.elementtype}`;
          const fieldConfig = ProposalFieldsJSON[labelKey];

          const displayDependent = fieldConfig?.["display-dependent"];
          const displayIndex = fieldConfig?.["display-index"];
          const dependentParentValue = displayDependent
            ? parsedProposal[displayDependent]
            : null;

          let shouldDisplayFieldset = true;

          if (displayDependent) {
            if (
              dependentParentValue === undefined ||
              dependentParentValue === null ||
              dependentParentValue === ""
            ) {
              shouldDisplayFieldset = false;
            } else if (displayIndex !== undefined) {
              shouldDisplayFieldset =
                Number(dependentParentValue) >= Number(displayIndex);
            } else {
              shouldDisplayFieldset = !!dependentParentValue;
            }
          }

          if (fieldConfig?.["display-hidden"] === 1) {
            shouldDisplayFieldset = false;
          }

          if (shouldDisplayFieldset) {
            const legend =
              fieldConfig?.["display-legend"] ||
              fieldConfig?.["display-fieldlabel"] ||
              child.name ||
              "Details";

            fields.push(
              <div
                key={child.elementid}
                className="w-100 my-2"
                style={{ gridColumn: "span 3" }}
              >
                <fieldset className="form-fieldset border p-2 mb-2">
                  <legend className="px-2 fs-6 fw-bold float-none w-auto">
                    {legend}
                  </legend>
                  <Row className="form-row">
                    {child.child && renderChildFields(child.child)}
                  </Row>
                </fieldset>
              </div>,
            );
          }
        } else if (
          child.elementtype === "select" ||
          child.elementtype === "textfield" ||
          child.elementtype === "email" ||
          child.elementtype === "date" ||
          child.elementtype === "number" ||
          child.elementtype === "textarea" ||
          child.elementtype === "multiselect" ||
          child.elementtype === "file" ||
          child.elementtype === "year"
        ) {
          const labelKey = `${child.elementid}-${child.elementtype}`;
          const fieldLabel =
            ProposalFieldsJSON[labelKey]?.["display-fieldlabel"] ||
            child.elementid;

          const databaseLabel =
            ProposalFieldsJSON[labelKey]?.["database-label"];
          const elementtype = ProposalFieldsJSON[labelKey]?.["elementtype"];
          const fieldValue = parsedProposal[databaseLabel];
          const displayYesKey = ProposalFieldsJSON[labelKey]?.["display-yes"];
          const displayNoKey = ProposalFieldsJSON[labelKey]?.["display-no"];

          const parentAttributeKey =
            ProposalFieldsJSON[labelKey]?.["parentattributekey"];

          const parentValue = parentAttributeKey
            ? parsedProposal[parentAttributeKey]
            : null;

          let shouldDisplayField = true;

          const displayDependent =
            ProposalFieldsJSON[labelKey]?.["display-dependent"];
          const displayIndex = ProposalFieldsJSON[labelKey]?.["display-index"];
          const dependentParentValue = displayDependent
            ? parsedProposal[displayDependent]
            : null;

          if (displayDependent) {
            if (
              dependentParentValue === undefined ||
              dependentParentValue === null ||
              dependentParentValue === ""
            ) {
              shouldDisplayField = false;
            } else if (displayIndex !== undefined) {
              shouldDisplayField =
                Number(dependentParentValue) >= Number(displayIndex);
            } else {
              shouldDisplayField = !!dependentParentValue;
            }
          }

          if (parentValue === "no") {
            shouldDisplayField = false;
          }

          if (parentValue === "yes" || !parentAttributeKey) {
            if (!fieldValue && (displayYesKey || displayNoKey)) {
              shouldDisplayField = false;
            }
          }

          if (shouldDisplayField) {
            // Format the value based on element type
            let formattedValue = fieldValue;

            if (elementtype === "date") {
              formattedValue = formatDate(fieldValue);
            } else if (elementtype === "year") {
              formattedValue = formatYear(fieldValue);
            } else if (elementtype === "file") {
              if (parsedProposal[databaseLabel]?.file_name) {
                formattedValue = parsedProposal[databaseLabel].file_name;
              } else {
                formattedValue = "No file available";
              }
            } else if (
              elementtype === "multiselect" &&
              Array.isArray(fieldValue)
            ) {
              formattedValue = fieldValue.join(", ");
            }

            // Push the field to the list
            fields.push(
              <div className="form-view-field" key={child.elementid}>
                <div className="view-label">{fieldLabel} :</div>
                <div className="view-value">{formattedValue || "-"}</div>
              </div>,
            );
          }
        } else if (child.child) {
          fields.push(renderChildFields(child.child));
        }
      });

      return fields;
    };
    return (
      <div>
        {isNewRenderer ? (
          <div className="proposal-view-fit-container">
            <ProposalForm
              methods={craftFormMethods}
              isLoading={craftFormLoading}
              isError={craftFormError}
              rendererMode="view"
            />
          </div>
        ) : (
          <div className="proposal-container">
            <div className="form-json-view">
              {ProposalLayoutJSON.map((element, ind) => (
                <fieldset className="form-fieldset" key={element.elementid}>
                  <legend className="">
                    {element.name || `Section ${ind + 1}`}
                  </legend>
                  <Row className="form-row">
                    {element.child && renderChildFields(element.child)}
                  </Row>
                </fieldset>
              ))}
            </div>
          </div>
        )}
        {/* {!(detailsData.Policy_detail || detailsData.status === "CANCELLED") && (
          <div className="navigation-button-container single-element">
            {(
              checkButtonAccess ? checkButtonAccess("EDIT", "ORD_PRF") : true
            ) ? (
              <Button
                data-action="finish"
                variant="primary"
                className="next-button"
                // onClick={handleSubmit}
                onClick={(e) => handleSubmit(e, "finish")}
              >
                Submit
              </Button>
            ) : (
              ""
            )}
          </div>
        )} */}
      </div>
    );
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setMode("VIEW");
  };

  return (
    <Modal
      isOpen={proposalShow}
      onHide={handleClose}
      centered
      className="border-0"
      contentClassName={
        isEditing || !detailsData.proposal_complete === true
          ? "proposal-modal-content"
          : undefined
      }
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
      size="xl"
    >
      <Form onSubmit={handleSubmit}>
        <ModalHeader
          className="p-3 bg-info-subtle form-render-header"
          toggle={handleClose}
        >
          <div className="d-flex w-100 align-items-center justify-content-between pe-3">
            <span>Proposal Form</span>
            <div className="d-flex gap-2">
              {(isEditing || !detailsData.proposal_complete) && (
                <Button
                  color="primary"
                  type="button"
                  className="primary-outline"
                  onClick={handleSaveDraft}
                  disabled={
                    isEditing && isNewRenderer
                      ? !craftFormValues ||
                        Object.values(craftFormValues).every(
                          (value) =>
                            value === "" ||
                            value === null ||
                            value === undefined,
                        )
                      : !formState ||
                        Object.values(formState).every((value) => value === "")
                  }
                >
                  Save Draft
                </Button>
              )}
              {detailsData.proposal_complete === true &&
              // detailsData.proposal_filled === 0 &&
              detailsData.status !== "CANCELLED" &&
              (checkButtonAccess
                ? checkButtonAccess("EDIT", "ORD_PRF")
                : true) ? (
                <>
                  <Button
                    className={isEditing ? "primary-outline" : "primary"}
                    onClick={isEditing ? handleCancelClick : handleEditClick}
                  >
                    {isEditing ? "Cancel" : "Edit"}
                  </Button>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </ModalHeader>
        <ModalBody
          className="modal-body"
          onMouseDown={handleModalBodyMouseDown}
          onClick={handleModalBodyClick}
        >
          {isEditing && isNewRenderer ? (
            <div className="proposal-form-fit-container">
              <ProposalForm
                isEditing={isEditing}
                methods={craftFormMethods}
                isLoading={craftFormLoading}
                isError={craftFormError}
              />
            </div>
          ) : isEditing || !detailsData.proposal_complete === true ? (
            <div>
              <div className="proposal-container">
                <div className="tab-wrapper">
                  {ProposalLayoutJSON?.map((element, ind) => (
                    // <div key={element.elementid}>
                    <div
                      key={element.elementid}
                      className={index === ind ? "active-tab" : "inactive-tab"}
                      style={{
                        pointerEvents: ind <= index ? "auto" : "none",
                        opacity: ind <= index ? 1 : 0.5,
                      }}
                    >
                      {renderElement(
                        element,
                        ProposalFieldsJSON,
                        formState,
                        () => {
                          setIndex(ind);
                        },
                        index,
                        ind,
                      )}
                    </div>
                  ))}
                </div>
                <div className="form-content">
                  {ProposalLayoutJSON[index]?.child?.length > 0 ? (
                    ProposalLayoutJSON[index]?.child.map((it) =>
                      renderElement(
                        it,
                        ProposalFieldsJSON,
                        formState,
                        null,
                        null,
                        false,
                      ),
                    )
                  ) : (
                    <p>No fields to display</p>
                  )}
                </div>
              </div>
              <div className="navigation-button-container">
                <Button
                  className="previous primary-outline"
                  color="primary"
                  onClick={handlePrevious}
                  disabled={index === 0}
                >
                  Previous
                </Button>
                <div className="navigation-button-container-right">
                  {index === ProposalLayoutJSON.length - 1 ? (
                    <Button
                      className="finish"
                      type="submit"
                      color="success"
                      // data-action="finish"
                      // onClick={(e) => handleSubmit(e, "finish")}
                      // disabled={detailsData.Policy_detail}
                    >
                      Finish
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      color="primary"
                      // data-action="next"
                      // onClick={(e) => handleSubmit(e, "next")}
                      disabled={index === ProposalLayoutJSON.length - 1}
                    >
                      Next
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ) : (
            renderProposalJson()
          )}
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default ProposalModal;
